import { useEffect, useState } from "react";

import { AdminShell } from "@/components/admin/admin-shell";
import {
  CategoryNavRow,
  HeaderNavConfigData,
  HeaderNavManager
} from "@/components/admin/header-nav-manager";
import { apiGet } from "@/services/api";

const DEFAULT_CONFIG: HeaderNavConfigData = {
  showAllButton: true,
  showDeals: true,
  dealsLabel: "Today's Deals",
  dealsHref: "/search?deal=flash",
  showPrime: true,
  primeLabel: "Prime",
  primeHref: "/prime",
  showCompare: true,
  compareLabel: "Compare",
  compareHref: "/compare",
  customLinks: []
};

export function AdminNavigationPage() {
  const [categories, setCategories] = useState<CategoryNavRow[]>([]);
  const [config, setConfig] = useState<HeaderNavConfigData>(DEFAULT_CONFIG);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    void apiGet<{ config?: HeaderNavConfigData; categories?: CategoryNavRow[] }>("/api/admin/nav")
      .then((data) => {
        if (!active) return;
        if (data?.categories) setCategories(data.categories);
        if (data?.config) {
          setConfig({
            ...DEFAULT_CONFIG,
            ...data.config,
            customLinks: Array.isArray(data.config.customLinks) ? data.config.customLinks : []
          });
        }
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  const handleSaved = (savedConfig: HeaderNavConfigData, savedCategories: CategoryNavRow[]) => {
    setConfig(savedConfig);
    setCategories(savedCategories);
  };

  return (
    <AdminShell
      title="Header Navigation"
      subtitle="Manage which categories and action links appear in the MOVA storefront sub-header bar."
    >
      {loading ? (
        <div className="flex h-64 items-center justify-center rounded-xl border border-slate-200 bg-white dark:border-white/10 dark:bg-slate-900">
          <div className="flex items-center gap-2 text-sm text-slate-500 dark:text-slate-400">
            <span className="h-4 w-4 animate-spin rounded-full border-2 border-amazon-orange border-t-transparent" />
            <span>Loading navigation settings...</span>
          </div>
        </div>
      ) : (
        <HeaderNavManager
          key="ready"
          initialCategories={categories}
          initialConfig={config}
          onSaved={handleSaved}
        />
      )}
    </AdminShell>
  );
}